module.exports.getStartPolicies = () => {
    const clustersDto = {}

    getPolicyList().clusters.forEach(cluster => {
        clustersDto[cluster.name] = {}
        cluster.categories.forEach(category => {
            clustersDto[cluster.name][category.name] = category.default
        })
    })

    return clustersDto
}


module.exports.getPolicyList = getPolicyList
function getPolicyList() {
    return {
        "clusters": [{
            "name": "Vnitřní politika",
            "categories": [{
                "name": "Rodinné poměry",
                "default": "Normální",
                "relationship": false,
                "policies": ["Velmi konzervativní (nukleární rodina)", "Dekadence", "Rodina by neměla existovat", "Normální"]
            },{
                "name": "Národnostní politika",
                "default": "Národnosti nejsou tak důležité",
                "relationship": false,
                "policies": ["Ruský šovinismus", "Absolutní internacionalismus (kvóty pro menšiny)", "Oblíbený národ (neruský) + Nenáviděný národ zrádců", "Národnosti nejsou tak důležité"]
            },{
                "name": "Náboženství",
                "default": "Omezená náboženská tolerance",
                "relationship": false,
                "policies": ["Militantní atheismus", "Hardcore ortodoxní křesťanství", "Mysticismus", "Omezená náboženská tolerance"]
            },{
                "name": "Ekonomika",
                "default": "Normální",
                "relationship": false,
                "policies": ["Bohatství je nutnost pro to být členem politbyra", "Být bohatý je nežádoucí", "Střední třída je nejlepší", "Normální"]
            }]
        },{
            "name": "Názory Vůdce",
            "categories": [{
                "name": "Gender",
                "default": "Nezáleží",
                "relationship": false,
                "policies": ["Nezáleží", "Moc patří mužům", "Moc patří ženám"]
            },{
                "name": "Filosofie",
                "default": "Vyvážená",
                "relationship": false,
                "policies": ["Vyvážená", "Futurismus", "Tradicionalismus"]
            }]
        },{
            "name": "Vztahy s mocnostmi",
            "categories": [{
                "name": "Německo",
                "default": "Neutrální",
                "relationship": true,
                "policies": ["Válka", "Rivalita", "Neutrální", "Inspirativní", "Spojenec"]
            },{
                "name": "Japonsko",
                "default": "Neutrální",
                "relationship": true,
                "policies": ["Válka", "Rivalita", "Neutrální", "Inspirativní", "Spojenec"]
            },{
                "name": "Velká Británie",
                "default": "Neutrální",
                "relationship": true,
                "policies": ["Válka", "Rivalita", "Neutrální", "Inspirativní", "Spojenec"]
            },{
                "name": "Spojené státy americké",
                "default": "Neutrální",
                "relationship": true,
                "policies": ["Válka", "Rivalita", "Neutrální", "Inspirativní", "Spojenec"]
            },{
                "name": "Čína",
                "default": "Neutrální",
                "relationship": true,
                "policies": ["Válka", "Rivalita", "Neutrální", "Inspirativní", "Spojenec"]
            },{
                "name": "Turecko",
                "default": "Neutrální",
                "relationship": true,
                "policies": ["Válka", "Rivalita", "Neutrální", "Inspirativní", "Spojenec"]
            }]
        }
        ]
    }
}
